import { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../NotFound'

import { AbilityContext } from '../../components/Ability'
import { useUser } from '../../hooks/useUser'
import AddressPage from './Features/Address'
import ChatIntegrationsPage from './Features/ChatIntegrations'
import DistributionChannelsPage from './Features/DistributionChannels'
import GeneralPage from './Features/General'
import ShippingSettingsPage from './Features/ShippingSettings'

const SettingPage = () => {
  const ability = useContext(AbilityContext)
  const { user } = useUser()

  return (
    <Routes>
      <Route
        path="/distribution-channel/*"
        element={
          ability.can('manage', 'Setting', 'saleChannel') ? (
            <DistributionChannelsPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/address/*"
        element={
          ability.can('manage', 'Setting', 'addressBook') ? (
            <AddressPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/chat-integrations/*"
        element={
          ability.can('manage', 'Setting', 'addressBook') ? (
            <ChatIntegrationsPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/shipping-settings/*"
        element={
          ability.can('manage', 'Setting', 'shipping') ||
          user?.isEnableShippingSettings ? (
            <ShippingSettingsPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/*"
        element={
          ability.can('manage', 'Setting', 'generalSetting') ? (
            <GeneralPage />
          ) : (
            <NotFound />
          )
        }
      />
    </Routes>
  )
}

export default SettingPage
